import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the agency tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['admin/findAgenciesWidgetModule/get']
}

/**
 * Returns the sets of selected agencies.
 *
 * @return Object
 */
export const selectedAgencySets = () => {
  return store.getters['admin/findAgenciesWidgetModule/agencySelectionSets']
}

/**
 * Returns agencies that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedAgencies = (set) => {
  if (store.getters['admin/findAgenciesWidgetModule/agencySelectionSets'].hasOwnProperty(set)) {
    return store.getters['admin/findAgenciesWidgetModule/agencySelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns the first selected agency in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedAgency = (set) => {
  if (store.getters['admin/findAgenciesWidgetModule/agencySelectionSets'].hasOwnProperty(set)) {
    const agencies = store.getters['admin/findAgenciesWidgetModule/agencySelectionSets'][set]
    const agencyIds = Object.keys(agencies)
    if (agencyIds.length > 0) {
      return agencies[agencyIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns the first selected agency's id in the specified set
 * or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedAgencyId = (set) => {
  const agency = selectedAgency(set)
  return agency === null ? null : agency.id
}

/**
 * Returns true if the specified agency is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedAgencies(set).hasOwnProperty(id)
}

/**
 * Returns either a agency object or null depending on whether
 * queries should be made by agency.
 *
 * @return Object|null
 */
export const getAgency = () => {
  return store.getters['admin/findAgenciesWidgetModule/getAgency']
}

/**
 * Load the status data of the agencies being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('admin/findAgenciesWidgetModule/query')
}

/**
 * Add a map or array of object agencies that have been selected within
 * the specified set.
 *
 * @param set String
 * @param agencies Array|Map
 */
export const addSelectedAgencies = (set, agencies) => {
  store.commit('admin/findAgenciesWidgetModule/addSelectedAgencies', { set, agencies })
}

/**
 * Set a single selected agency, all other selected agencies
 * in the set will be cleared.
 *
 * @param set String
 * @param agency Object
 */
export const setSelectedAgency = (set, agency) => {
  store.commit('admin/findAgenciesWidgetModule/setSelectedAgency', { set, agency })
}

/**
 * Removes an array of agencies from the set's list of selected agencies.
 * The array must consist of the id's of the agencies that are no
 * longer selected.
 *
 * @param set String
 * @param agencies Array
 */
export const removeSelectedAgencies = (set, agencies) => {
  store.commit('admin/findAgenciesWidgetModule/removeSelectedAgencies', { set, agencies })
}

/**
 * Clears all selected agencies within a specified set.
 */
export const clearSelectedAgencies = (set) => {
  store.commit('admin/findAgenciesWidgetModule/clearSelectedAgencies', set)
}

/**
 * Clears all selected agencies.
 */
export const clearAllSelectedAgencies = () => {
  store.commit('admin/findAgenciesWidgetModule/clearAllSelectedAgencies')
}

/**
 * Returns the selected agency count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedAgencyCount = (set) => {
  return Object.keys(selectedAgencies(set)).length
}

/**
 * Clears all agencies from being tracked.
 */
export const purge = () => {
  store.commit('admin/findAgenciesWidgetModule/purge')
}



// WEBPACK FOOTER //
// ./src/store/administration/agencies/findAgenciesWidget.helpers.js